import { useMemo } from 'react';
import ChevronOption from '../components/ChevronOption';
import ConnectedMenu from '../components/ConnectedMenu';
import CountMultiValue from '../components/CountMultiValue';
import CustomInput from '../components/CustomInput';
import DropdownIndicator from '../components/DropdownIndicator';
import IconValueContainer from '../components/IconValueContainer';
import SimplifiedOption from '../components/SimplifiedOption';
import { useTheme } from '@xstyled/styled-components';
import { getCustomTheme as getFormCustomTheme, CustomStyles as SelectCustomStyles } from './selectStyles';
export var useStylesAndComponents = function (style, optionVariant, multiLabelVariant, containerVariant, useSimplifiedOptions, showSelectAllButton, showResetGridButton) {
    if (style === void 0) { style = 'form'; }
    if (optionVariant === void 0) { optionVariant = 'default'; }
    if (multiLabelVariant === void 0) { multiLabelVariant = 'default'; }
    if (containerVariant === void 0) { containerVariant = 'default'; }
    if (useSimplifiedOptions === void 0) { useSimplifiedOptions = false; }
    if (showSelectAllButton === void 0) { showSelectAllButton = false; }
    if (showResetGridButton === void 0) { showResetGridButton = false; }
    var systemTheme = useTheme();
    return useMemo(function () {
        var components = {
            ValueContainer: IconValueContainer
        };
        if (multiLabelVariant === 'count') {
            components.MultiValue = CountMultiValue;
        }
        if (containerVariant === 'search') {
            components.DropdownIndicator = null;
        }
        if (showResetGridButton || showSelectAllButton) {
            components.MenuList = ConnectedMenu;
        }
        components.Input = CustomInput;
        var themes = getFormCustomTheme(systemTheme, optionVariant, style == 'gridFilter');
        var styles = SelectCustomStyles;
        components.Option = ChevronOption;
        components.DropdownIndicator = DropdownIndicator;
        // performance reasons
        if (useSimplifiedOptions)
            components.Option = SimplifiedOption;
        return [components, themes, styles];
    }, [
        multiLabelVariant,
        containerVariant,
        showResetGridButton,
        showSelectAllButton,
        style,
        useSimplifiedOptions,
        systemTheme,
        optionVariant
    ]);
};
